[
  {
    "code": "GN-B",
    "name": "Boké, Gouvernorat de"
  },
  {
    "code": "GN-C",
    "name": "Conakry"
  },
  {
    "code": "GN-F",
    "name": "Faranah, Gouvernorat de"
  },
  {
    "code": "GN-K",
    "name": "Kankan, Gouvernorat de"
  },
  {
    "code": "GN-D",
    "name": "Kindia, Gouvernorat de"
  },
  {
    "code": "GN-L",
    "name": "Labé, Gouvernorat de"
  },
  {
    "code": "GN-M",
    "name": "Mamou, Gouvernorat de"
  },
  {
    "code": "GN-N",
    "name": "Nzérékoré, Gouvernorat de"
  }
]